const selectUser = (state) => state.user.current;
const selectAuthenticated = (state) => state.user.authenticated;
const selectIsFulfilled = (state) => state.user.isFulfilled;

export { selectAuthenticated, selectIsFulfilled, selectUser };
//# sourceMappingURL=user.js.map
